"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ConfirmedBasket = _interopRequireDefault(require("./ConfirmedBasket"));
var _Customer = _interopRequireDefault(require("./Customer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The OnlineCashPayment model module.
 * @module model/OnlineCashPayment
 * @version 3.0
 */
var OnlineCashPayment = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>OnlineCashPayment</code>.
   * @alias module:model/OnlineCashPayment
   */
  function OnlineCashPayment() {
    _classCallCheck(this, OnlineCashPayment);
    OnlineCashPayment.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(OnlineCashPayment, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>OnlineCashPayment</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OnlineCashPayment} obj Optional instance to populate.
     * @return {module:model/OnlineCashPayment} The populated <code>OnlineCashPayment</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new OnlineCashPayment();
        if (data.hasOwnProperty('paymentId')) {
          obj['paymentId'] = _ApiClient["default"].convertToType(data['paymentId'], 'Number');
        }
        if (data.hasOwnProperty('basketId')) {
          obj['basketId'] = _ApiClient["default"].convertToType(data['basketId'], 'Number');
        }
        if (data.hasOwnProperty('amount')) {
          obj['amount'] = _ApiClient["default"].convertToType(data['amount'], 'Number');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('gateway')) {
          obj['gateway'] = _ApiClient["default"].convertToType(data['gateway'], 'String');
        }
        if (data.hasOwnProperty('confirmedBasketHash')) {
          obj['confirmedBasketHash'] = _ApiClient["default"].convertToType(data['confirmedBasketHash'], 'String');
        }
        if (data.hasOwnProperty('customer')) {
          obj['customer'] = _Customer["default"].constructFromObject(data['customer']);
        }
        if (data.hasOwnProperty('confirmedBasket')) {
          obj['confirmedBasket'] = _ConfirmedBasket["default"].constructFromObject(data['confirmedBasket']);
        }
        if (data.hasOwnProperty('barCode')) {
          obj['barCode'] = _ApiClient["default"].convertToType(data['barCode'], 'String');
        }
        if (data.hasOwnProperty('qrCode')) {
          obj['qrCode'] = _ApiClient["default"].convertToType(data['qrCode'], 'String');
        }
        if (data.hasOwnProperty('reference')) {
          obj['reference'] = _ApiClient["default"].convertToType(data['reference'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OnlineCashPayment</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OnlineCashPayment</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['gateway'] && !(typeof data['gateway'] === 'string' || data['gateway'] instanceof String)) {
        throw new Error("Expected the field `gateway` to be a primitive type in the JSON string but got " + data['gateway']);
      }
      // ensure the json data is a string
      if (data['confirmedBasketHash'] && !(typeof data['confirmedBasketHash'] === 'string' || data['confirmedBasketHash'] instanceof String)) {
        throw new Error("Expected the field `confirmedBasketHash` to be a primitive type in the JSON string but got " + data['confirmedBasketHash']);
      }
      // validate the optional field `customer`
      if (data['customer']) {
        // data not null
        _Customer["default"].validateJSON(data['customer']);
      }
      // validate the optional field `confirmedBasket`
      if (data['confirmedBasket']) {
        // data not null
        _ConfirmedBasket["default"].validateJSON(data['confirmedBasket']);
      }
      // ensure the json data is a string
      if (data['barCode'] && !(typeof data['barCode'] === 'string' || data['barCode'] instanceof String)) {
        throw new Error("Expected the field `barCode` to be a primitive type in the JSON string but got " + data['barCode']);
      }
      // ensure the json data is a string
      if (data['qrCode'] && !(typeof data['qrCode'] === 'string' || data['qrCode'] instanceof String)) {
        throw new Error("Expected the field `qrCode` to be a primitive type in the JSON string but got " + data['qrCode']);
      }
      // ensure the json data is a string
      if (data['reference'] && !(typeof data['reference'] === 'string' || data['reference'] instanceof String)) {
        throw new Error("Expected the field `reference` to be a primitive type in the JSON string but got " + data['reference']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} paymentId
 */
OnlineCashPayment.prototype['paymentId'] = undefined;

/**
 * @member {Number} basketId
 */
OnlineCashPayment.prototype['basketId'] = undefined;

/**
 * @member {Number} amount
 */
OnlineCashPayment.prototype['amount'] = undefined;

/**
 * @member {String} currency
 */
OnlineCashPayment.prototype['currency'] = undefined;

/**
 * @member {String} gateway
 */
OnlineCashPayment.prototype['gateway'] = undefined;

/**
 * @member {String} confirmedBasketHash
 */
OnlineCashPayment.prototype['confirmedBasketHash'] = undefined;

/**
 * @member {module:model/Customer} customer
 */
OnlineCashPayment.prototype['customer'] = undefined;

/**
 * @member {module:model/ConfirmedBasket} confirmedBasket
 */
OnlineCashPayment.prototype['confirmedBasket'] = undefined;

/**
 * @member {String} barCode
 */
OnlineCashPayment.prototype['barCode'] = undefined;

/**
 * @member {String} qrCode
 */
OnlineCashPayment.prototype['qrCode'] = undefined;

/**
 * @member {String} reference
 */
OnlineCashPayment.prototype['reference'] = undefined;
var _default = exports["default"] = OnlineCashPayment;